import React, { FC, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import RoutesConfig from './shared/routes/RoutesConfig';
import { ThemeProvider } from "./shared/context/ThemeContext";
import {fetchTempToken, setToken} from "./store/slices/authSlice";
import { useAppDispatch } from "./store/store";

const App: FC = () => {
    const dispatch = useAppDispatch();
    const location = useLocation();


    useEffect(() => {
        const autoOverflowPaths = ['/privacy-policy', '/terms-of-use', '/eula'];
        document.body.style.overflow = autoOverflowPaths.includes(location.pathname) ? 'auto' : 'hidden';

        return () => {
            document.body.style.overflow = '';
        };
    }, [location.pathname]);

    useEffect(() => {
        const storedToken = localStorage.getItem('authToken');

        if (storedToken) {
            dispatch(setToken(storedToken));
        } else {
            dispatch(fetchTempToken());
        }
    }, [dispatch]);

    return (
        <ThemeProvider>
            <RoutesConfig />
        </ThemeProvider>
    );
};

export default App;
